/* Review slider: scroll-snap track, arrows and dots move one page (cards per view) at a time. */
if (!customElements.get('m-review-slider')) {
  class MReviewSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rs-track]');
      this.dotsWrap = this.querySelector('[data-rs-dots]');
      if (!this.track) return;

      this.querySelector('[data-rs-prev]')?.addEventListener('click', () => this.go(this.page() - 1));
      this.querySelector('[data-rs-next]')?.addEventListener('click', () => this.go(this.page() + 1));
      this.track.addEventListener('scroll', () => window.requestAnimationFrame(() => this.sync()), { passive: true });

      this.build();
      this.resizeObserver = new ResizeObserver(() => this.build());
      this.resizeObserver.observe(this.track);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    step() {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return this.track.clientWidth + gap;
    }

    pages() {
      const perView = parseInt(getComputedStyle(this).getPropertyValue('--rs-per-view'), 10) || 1;
      return Math.max(1, Math.ceil(this.track.children.length / perView));
    }

    page() {
      return Math.round(this.track.scrollLeft / Math.max(this.step(), 1));
    }

    go(index) {
      const total = this.pages();
      const next = (index + total) % total;
      this.track.scrollTo({ left: next * this.step(), behavior: 'smooth' });
    }

    build() {
      const total = this.pages();
      if (total === this.total) return this.sync();
      this.total = total;
      this.classList.toggle('is-static', total < 2);
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = '';
      for (let i = 0; i < total; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'm-review-slider__dot';
        dot.setAttribute('aria-label', `Show reviews page ${i + 1}`);
        dot.addEventListener('click', () => this.go(i));
        this.dotsWrap.appendChild(dot);
      }
      this.sync();
    }

    sync() {
      if (!this.dotsWrap) return;
      const current = Math.min(this.page(), this.pages() - 1);
      this.dotsWrap.querySelectorAll('.m-review-slider__dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    }
  }

  customElements.define('m-review-slider', MReviewSlider);
}
